import React from 'react';
import { InfoFilled } from '../shared-components/icons';
import PropTypes from 'prop-types';

const InfoBar = ({ labelInfo }) => (
  <div className="flex padding-md" style={{ color: '#886A2F', backgroundColor: '#F7F3EB' }}>
    <div>
      <InfoFilled className="text-md" style={{ marginTop: '2px' }}/>
    </div>
    <div className="margin-md-left text-cream-dark text-small">
      {labelInfo}
    </div>
  </div>
);

InfoBar.propTypes = {
  labelInfo: PropTypes.string
};

export default InfoBar;
